module.exports = __webpack_public_path__ + "assets/images/USD1C.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD1C.png
// module id = 1453
// module chunks = 1